import { createSelector } from '@reduxjs/toolkit';
import { tasksNotDeleted } from '../responsibilities/tasks-not-deleted';
import { getOrganizationId } from '../organization/getOrganizationId';
import { getOrganization } from '../organization/getOrganization';
import { currentEmployeeFunctions } from '../responsibilities/current-employee-functions';
import { weekStart } from './week-start';
import { singleUserVersion } from '../organization/singleUserVersion';
import type { TaskInstance } from '../../types';
import { RecurrenceRule } from '../../recurrence-rule/recurrence-rule';
import { DayOfWeek, LocalDate, mondayThisWeek } from '../../../utilities/local-date';
import { sortBy } from 'lodash';

export const startTaskInstances = createSelector(
  tasksNotDeleted,
  getOrganizationId,
  getOrganization,
  currentEmployeeFunctions,
  weekStart,
  singleUserVersion,
  (tasks, organizationId, o, currentEmployeeFunctions, weekStart, singleUserVersion) => {
    let t: TaskInstance[] = [];
    tasks.forEach(function (task) {
      let add = false;
      let instance;
      let time;
      let done = '';
      if (task.locked && task.rrule) {
        const rule = RecurrenceRule.fromString(task.rrule);
        const thisWeek = mondayThisWeek();
        const date = rule.sameOrAfter(thisWeek);
        if (date) {
          time = date;
          instance = date;
          add = instance.withPreviousOrSame(DayOfWeek.MONDAY).isSame(LocalDate.fromString(weekStart));
        }
      } else if (task.lastExecuted) {
        time = LocalDate.fromString(task.lastExecuted);
        add = time.withPreviousOrSame(DayOfWeek.MONDAY).isSame(LocalDate.fromString(weekStart));
        done = time.toStringForDisplay();
      }
      if (add && time !== undefined) {
        let href = '/account/' + organizationId + '/' + 318434;
        href += '/functions/' + task.functionUuid;
        href += '/tasks/' + task.uuid;
        const myTask = currentEmployeeFunctions.includes(task.functionUuid);
        let functionNameDisplay = o?.functionsById[task.functionUuid]?.name ?? '';
        if (singleUserVersion) {
          functionNameDisplay = '';
        }
        t.push({
          instance: time,
          done: done,
          taskUuid: task.uuid,
          name: task.name,
          functionUuid: task.functionUuid,
          functionName: functionNameDisplay,
          href: href,
          time: time,
          myTask: myTask,
          timeOfDayDisplay: '',
        });
      }
    });
    t = sortBy(t, (e) => e.time);
    return t;
  },
);
